/**
 * My Learning folder endpoints.
 */
import type {
  BreadcrumbsResponse,
  FolderItem,
  FoldersListResponse,
} from '@/types/api';
import { apiClient } from './client';

/**
 * Folders API endpoints
 */
export const folderApi = {
  /**
   * List folders for the current user.
   * - omit parentId: returns the full flat list (good for tree building)
   * - parentId='root': top-level folders only
   * - parentId=<uuid>: direct children of that folder
   */
  listFolders: (parentId?: string | 'root') => {
    const query = new URLSearchParams();
    if (parentId) query.append('parent_id', parentId);
    const qs = query.toString();
    return apiClient.get<FoldersListResponse>(
      qs ? `/folders?${qs}` : '/folders'
    );
  },

  getFolder: (folderId: string) =>
    apiClient.get<FolderItem>(`/folders/${folderId}`),

  getBreadcrumbs: (folderId: string) =>
    apiClient.get<BreadcrumbsResponse>(`/folders/${folderId}/breadcrumbs`),

  createFolder: (data: {
    name: string;
    parent_folder_id?: string | null;
    tags?: string[];
  }) => apiClient.post<FolderItem>('/folders', data),

  updateFolder: (
    folderId: string,
    data: {
      name?: string;
      tags?: string[];
      parent_folder_id?: string | null;
    }
  ) => apiClient.patch<FolderItem>(`/folders/${folderId}`, data),

  deleteFolder: (folderId: string) => apiClient.delete(`/folders/${folderId}`),
};
